export interface IPlanDetails {
  planName: string;
  sublineName: string;
  lineName: string;
  externalCode: string;
  arabicName: string;
  effectiveFrom: string;
  effectiveTo: string;
  status: string;
  planCurrencySymbol: string;
}

export const initialValues: IPlanDetails = {
  planName: '',
  sublineName: '',
  lineName: '',
  externalCode: '',
  arabicName: '',
  effectiveFrom: '',
  effectiveTo: '',
  status: '',
  planCurrencySymbol: '',
};

export interface IGenericPolicyCoverTableData {
  planConfigManagement_PolicyCover_Id: string;
  planConfigManagement_PolicyCover_Name: string;
  planConfigManagement_PolicyCover_ExternalCode: string;
  planConfigManagement_PolicyCover_NameArabic: string;
  planConfigManagement_PolicyCover_PrintingOrder: string;
  planConfigManagement_PolicyCover_PolicyCoverDescription: string;
  planConfigManagement_PolicyCover_createdOn: string;
  planConfigManagement_PolicyCover_modifiedOn: string;
  planConfigManagement_PolicyCover_LineID: {
    views: {
      PlanConfigManagement_all: {
        properties: {
          ExternalCode: string;
          Name: string;
        };
      };
    };
  };
}

export interface IGenericAllRiskPlanRatesTableData {
  planConfigManagement_PlanSpecificAllRisk_Id: string;
  planConfigManagement_PlanSpecificAllRisk_PlanID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          PlanCurrency: {
            Id: string;
            Code: string;
            Title: string;
            Symbol: string;
          };
        };
      };
    };
  };
  planConfigManagement_PlanSpecificAllRisk_CarAgeFrom: string;
  planConfigManagement_PlanSpecificAllRisk_CarAgeTo: string;
  planConfigManagement_PlanSpecificAllRisk_CarValueFrom: string;
  planConfigManagement_PlanSpecificAllRisk_CarValueTo: string;
  planConfigManagement_PlanSpecificAllRisk_CarCategory: {
    Id: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificAllRisk_MinimumPremium: string;
  planConfigManagement_PlanSpecificAllRisk_Rate: string;
  planConfigManagement_PlanSpecificAllRisk_AgencyYear: string;
  planConfigManagement_PlanSpecificAllRisk_NoDepreciationYear: string;
}

export interface IGenericExpatPlanRatesTableData {
  planConfigManagement_PlanSpecificExpat_Id: string;
  planConfigManagement_PlanSpecificExpat_AgeFrom: string;
  planConfigManagement_PlanSpecificExpat_AgeTo: string;
  planConfigManagement_PlanSpecificExpat_Gender: string;
  planConfigManagement_PlanSpecificExpat_OccupationClass: {
    Code: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificExpat_Nationality: [
    {
      Code: string;
      Title: string;
    },
  ];
  planConfigManagement_PlanSpecificExpat_Premium: string;
  planConfigManagement_PlanSpecificExpat_Emergency: string;
  planConfigManagement_PlanSpecificExpat_MedicalClass: {
    Code: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificExpat_PlanID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          PlanCurrency: {
            Id: string;
            Code: string;
            Title: string;
            Symbol: string;
          };
        };
      };
    };
  };
}

export interface IGenericTravelPlanRatesTableData {
  planConfigManagement_PlanSpecificTravel_Id: string;
  planConfigManagement_PlanSpecificTravel_AgeFrom: string;
  planConfigManagement_PlanSpecificTravel_AgeTo: string;
  planConfigManagement_PlanSpecificTravel_TravelDurationFrom: string;
  planConfigManagement_PlanSpecificTravel_TravelDurationTo: string;
  planConfigManagement_PlanSpecificTravel_TravelDestination: {
    Id: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificTravel_NumberOfAdults: string;
  planConfigManagement_PlanSpecificTravel_NumberOfChildren: string;
  planConfigManagement_PlanSpecificTravel_Premium: string;
  planConfigManagement_PlanSpecificTravel_Gender: string;
  planConfigManagement_PlanSpecificTravel_NbOfAdherent: string;
  planConfigManagement_PlanSpecificTravel_PolicyCoverID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          Name: string;
        };
      };
    };
  };
  planConfigManagement_PlanSpecificTravel_PlanID: {
    views: {
      PlanConfigManagement_all: {
        properties: {
          PlanCurrency: {
            Id: string;
            Code: string;
            Title: string;
            Symbol: string;
          };
        };
      };
    };
  };
  planConfigManagement_PlanSpecificTravel_IsMain: boolean;
  planConfigManagement_PlanSpecificTravel_IsMandatory: boolean;
  planConfigManagement_PlanSpecificTravel_IsEditable: boolean;
  planConfigManagement_PlanSpecificTravel_SumInsured: string;
  planConfigManagement_PlanSpecificTravel_SumInsuredIsAdditive?: boolean;
  planConfigManagement_PlanSpecificTravel_TPAType: string;
  planConfigManagement_PlanSpecificTravel_TPAFeesPercentage?: string;
  planConfigManagement_PlanSpecificTravel_TPAFeesAmount: string;
  planConfigManagement_PlanSpecificTravel_MinTPAFees: string;
  planConfigManagement_PlanSpecificTravel_MaxTPAFees: string;
  planConfigManagement_PlanSpecificTravel_ExcessOnClaimType: string;
  planConfigManagement_PlanSpecificTravel_ExcessOnClaimAmount: string;
  planConfigManagement_PlanSpecificTravel_ExcessOnClaimPercentage: string;
  planConfigManagement_PlanSpecificTravel_ExcessOnClaimDays: string;
  planConfigManagement_PlanSpecificTravel_ClauseID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          ExternalCode: string;
          Name: string;
        };
      };
    };
  };
}

export interface IGenericMedicalPlanRatesTableData {
  planConfigManagement_PlanSpecificMedical_Id: string;
  planConfigManagement_PlanSpecificMedical_PolicyCoverID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          Name: string;
        };
      };
    };
  };
  planConfigManagement_PlanSpecificMedical_NbOfAdherent: string;
  planConfigManagement_PlanSpecificMedical_Class: {
    Code: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificMedical_AgeFrom: string;
  planConfigManagement_PlanSpecificMedical_AgeTo: string;
  planConfigManagement_PlanSpecificMedical_CoNssf: string;
  planConfigManagement_PlanSpecificMedical_NetPremium: string;
  planConfigManagement_PlanSpecificMedical_TPAFeesPercentage: string;
  planConfigManagement_PlanSpecificMedical_MinTPAFees: string;
  planConfigManagement_PlanSpecificMedical_MaxTPAFees: string;
  planConfigManagement_PlanSpecificMedical_ExcessOnClaimType: string;
  planConfigManagement_PlanSpecificMedical_ExcessOnClaimAmount: number;
  planConfigManagement_PlanSpecificMedical_ExcessOnClaimPercentage: number;
  planConfigManagement_PlanSpecificMedical_ExcessOnClaimDays: string;
  planConfigManagement_PlanSpecificMedical_IsEditable: string;
  planConfigManagement_PlanSpecificMedical_IsMain: string;
  planConfigManagement_PlanSpecificMedical_IsMandatory: string;
  planConfigManagement_PlanSpecificMedical_SumInsured: string;
  planConfigManagement_PlanSpecificMedical_SumInsuredIsAdditive: string;
  planConfigManagement_PlanSpecificMedical_Level: {
    Code: string;
    Id: string;
    Title: string;
  };
  planConfigManagement_PlanSpecificMedical_ClauseID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          ExternalCode: string;
          Name: string;
        };
      };
    };
  };
  planConfigManagement_PlanSpecificMedical_PlanID: {
    views: {
      PlanConfigManagement_all: {
        properties: {
          PlanCurrency: {
            Id: string;
            Code: string;
            Title: string;
            Symbol: string;
          };
        };
      };
    };
  };
  planConfigManagement_PlanSpecificMedical_TPAType?: string;
  planConfigManagement_PlanSpecificMedical_TPAAmount?: string;
}

export interface IGenericPlanCoversRatesTableData {
  planConfigManagement_PlanCover_Id: string;
  planConfigManagement_PlanCover_PolicyCoverID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          ExternalCode: string;
          Name: string;
        };
      };
    };
  };
  planConfigManagement_PlanCover_IsMain: string;
  planConfigManagement_PlanCover_IsMandatory: string;
  planConfigManagement_PlanCover_IsEditable: string;
  planConfigManagement_PlanCover_CoverSumInsured: number | null;
  planConfigManagement_PlanCover_SumInsuredIsAdditive: string;
  planConfigManagement_PlanCover_CoverPremiumType: string;
  planConfigManagement_PlanCover_CoverPremiumValue: number | null;
  planConfigManagement_PlanCover_CoverPremiumPercentage: number | null;
  planConfigManagement_PlanCover_PlanID: {
    views: {
      PlanConfigManagement_all: {
        properties: {
          PlanCurrency: {
            Id: string;
            Code: string;
            Title: string;
            Symbol: string;
          };
        };
      };
    };
  };
  planConfigManagement_PlanCover_ExcessOnClaimType: string;
  planConfigManagement_PlanCover_ExcessOnClaimAmount: number | null;
  planConfigManagement_PlanCover_ExcessOnClaimPercentage: number | null;
  planConfigManagement_PlanCover_ExcessOnClaimDays: number | null;
  planConfigManagement_PlanCover_ClauseID: {
    id: string;
    views: {
      PlanConfigManagement_all: {
        properties: {
          ExternalCode: string;
          Name: string;
        };
      };
    };
  };
}
